import type { MutableRefObject } from "react";
import { isFroalaInComposedPath } from "../../../utils";
import { COLLAPSIBLE_TEXT_SELECTOR, LIVEBLOCKS_COMMENTS_SELECTOR } from "../constants";
import type { FroalaEditorInstance } from "../types";

export const createDocMouseDownHandler = (
  id: string,
  froalaInstance: MutableRefObject<FroalaEditorInstance | null>,
  elementRef: MutableRefObject<HTMLDivElement | null>,
  getLastFocusId: () => string,
) => {
  return (e: MouseEvent) => {
    const editor = froalaInstance.current;
    const editorRef = elementRef.current;
    if (!editor || !editorRef) return;

    const target = e.target as Element;
    const activeElement = target.closest(
      '.--active[data-element-name="RichText"]',
    );
    const isInsideEditorUI =
      activeElement ||
      target.closest(".fr-toolbar") ||
      target.closest(".fr-popup") ||
      target.closest('[role="dialog"]') ||
      target.closest('[data-rich-text-focus-ignore="true"]');

    if (!isInsideEditorUI) {
      editor.$el?.blur();
      editor.selection?.clear();
    }

    if (getLastFocusId() === id && editor.events?.focus) {
      const composedPath = e.composedPath();
      const foundFroala = isFroalaInComposedPath(composedPath);
      if (!editorRef.contains(e.target as Node)) {
        const clickTarget = e.target as HTMLElement;

        let shouldSkip = false;
        if (
          ["INPUT", "TEXTAREA", "EM-EMOJI-PICKER"].includes(
            clickTarget.nodeName,
          ) ||
          composedPath.find(
            (c) => c instanceof HTMLElement && c.nodeName === "BUTTON",
          ) ||
          composedPath.find(
            (c) =>
              c instanceof HTMLElement &&
              c.getAttribute("data-rich-text-focus-ignore") === "true",
          ) ||
          clickTarget.closest(COLLAPSIBLE_TEXT_SELECTOR) ||
          clickTarget.closest(LIVEBLOCKS_COMMENTS_SELECTOR) ||
          clickTarget.closest("[draggable]")
        ) {
          shouldSkip = true;
        }

        if (!shouldSkip && !foundFroala) {
          e.preventDefault();
          if (activeElement) editor.events.focus();
        }
      }
    }
  };
};
